class CustomerAuth extends HTMLElement {
    constructor() {
        super();

        this.auth = this;

        // Open login popup instead of sidebar
        if(document.querySelector('[data-open-auth-sidebar]')){
            document.querySelectorAll('[data-open-auth-sidebar]').forEach((openButton) =>
                openButton.addEventListener('click', this.setOpenLoginPopup.bind(this))
            );
        }

        // Keep sidebar close functionality for logged-in state
        if(document.querySelector('[data-close-auth-sidebar]')){
            document.querySelector('[data-close-auth-sidebar]').addEventListener(
                'click',
                this.setCloseSidebar.bind(this)
            );
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    isAuthenticated() {
        // Check sessionStorage authentication
        const authTime = sessionStorage.getItem('authTime');
        if (!authTime) return false;
        
        const SESSION_DURATION = 86400000; // 24 hours
        const elapsed = Date.now() - parseInt(authTime);
        
        if (elapsed > SESSION_DURATION) {
            sessionStorage.removeItem('userAuthenticated');
            sessionStorage.removeItem('authTime');
            sessionStorage.removeItem('customerEmail');
            return false;
        }
        
        return sessionStorage.getItem('userAuthenticated') === 'true';
    }

    setOpenLoginPopup(event){
        event.preventDefault();
        event.stopPropagation();

        // Check if customer is logged in via Shopify OR sessionStorage
        const isShopifyLoggedIn = window.Shopify && window.Shopify.customer;
        const isSessionAuthenticated = this.isAuthenticated();

        if (isShopifyLoggedIn || isSessionAuthenticated) {
            // Already logged in, show sidebar with account menu
            document.body.classList.add('auth-sidebar-show');
        } else {
            // Not logged in, open OTP popup
            if (typeof window.openAuthModal === 'function') {
                window.openAuthModal(true); // true = login flow
            }
        }
    }

    setCloseSidebar(event){
        event.preventDefault();
        event.stopPropagation();

        document.body.classList.remove('auth-sidebar-show');
    }
    
    onBodyClickEvent(event){
        if(document.body.classList.contains('auth-sidebar-show')){
            if ((!this.contains(event.target)) && 
                ($(event.target).closest('[data-open-auth-sidebar]').length === 0) && 
                ($(event.target).closest('[data-auth-sidebar]').length === 0)){
                event.stopImmediatePropagation();
                this.setCloseSidebar(event);
            }
        }
    }
}

customElements.define('customer-auth', CustomerAuth);
